import 'angular';

import { downgradeInjectable } from '@angular/upgrade/static';

import { CompaniesStates }               from './companies.states.ajs';
import { CompanyAdminStatusFilter }      from './company.admin-status.filter.ajs';
import { CompanyAdminStatusPipe }        from "./company.admin-status.pipe";
import { CompanyCtrl }                   from './company.ajs';
import { CompanyCustomizationsCtrl }     from './company.customizations.ajs';
import { CompanyCustomizationsService }  from './company.customizations.service';
import { CompanyMessagesCtrl }           from './company.messages.ajs';
import { CompanySettingsCtrl }           from './company.settings.ajs';
import { GoldUpgradeCtrl }               from './company.gold-upgrade';
import { SubscriptionTypeUpgradeCtrl }   from './company.subscription-type-upgrade';

import '../../app-lite/companies/companies.module.ajs';

angular.module('workshop.company', [
  'app-lite.companies'
])
  .config(CompaniesStates)
  .controller('CompanyCustomizationsCtrl', CompanyCustomizationsCtrl)
  .controller('CompanyMessagesCtrl', CompanyMessagesCtrl)
  .controller('companySettings', CompanySettingsCtrl)
  .controller('CompanyCtrl', CompanyCtrl)
  .controller('GoldUpgradeCtrl', GoldUpgradeCtrl)
  .controller('subscriptionTypeUpgradeCtrl', SubscriptionTypeUpgradeCtrl)
  .filter('companyAdminStatus', CompanyAdminStatusFilter)
  .service('companyAdminStatusPipe', downgradeInjectable(CompanyAdminStatusPipe))
  .service('companyCustomizationsApi', downgradeInjectable(CompanyCustomizationsService));
